export const SIGNUP_ACTION = 'SIGNUP_ACTION';
export const SIGNUP_SUCCESS_ACTION = 'SIGNUP_SUCCESS_ACTION';
export const SIGNUP_FAILURE_ACTION = 'SIGNUP_FAILURE_ACTION';
